import { createApp } from 'vue';
import store from './stores';
import router from './routes';
import App from './App.vue';
import ElementPlus from 'element-plus';

import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';

// 图标库 https://fontawesome.dashgame.com/
import 'font-awesome/css/font-awesome.min.css';
import '@/assets/styles/main.less';

const app = createApp(App);
app.use(router);
app.use(store);
// 引入ElementPlus组件库，使用中文
app.use(ElementPlus, {
  locale: zhCn
});

app.mount('#app');
